module.exports = __webpack_public_path__ + "static/junk-removal-single-4184edf026ff83ee539e4198774c998d.jpg";